var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarSubStream",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Sub Stream"
                                                : "Ver Detalle Sub Stream Howen"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: { sm8: "", md8: "", "d-flex": "" }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.resolution.label,
                                          items:
                                            _vm.formFields.resolution.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedResolution,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.resolution.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.resolution,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.resolution.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.frameRate.label,
                                          items: _vm.formFields.frameRate.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedFrameRate,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.frameRate.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.frameRate,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.frameRate.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.quality.label,
                                          items: _vm.formFields.quality.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedQuality,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.quality.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.quality,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.quality.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }